import StudentCoursesListPageContainer from '../../components/courses/studentCoursesList';

const StudentCoursesList = () => {
  return <StudentCoursesListPageContainer />;
};
export default StudentCoursesList;
